import { api } from "@/api";

export async function getCommonConfig(): Promise<any> {
  const res = await api.commonConfig();
  return res;
}

export async function getCommonChanges(): Promise<any> {
  const res = await api.commonChanges();
  return res;
}



export async function updateCommonConfig(payload: {
  LogoutTime: number;
  WarningTime: number;
  InactiveDays: number;
  TourIcon: boolean;
  NotificationIcon: boolean;
  LanguageSwitchIcon: boolean;
  FluxxURL: string;
  PowerBIURL: string;
}): Promise<any> {
  const res = await api.commonConfigUpdate(payload);
  return res;
}

export async function getRoleNames() {
  return api.getRoleNames();
}

export async function updateRoleNames(payload: any) {
  return api.updateRoleNames(payload);
}

export async function getWidgetNames() {
  return api.widgetNames();
}

export async function updateWidgetNames(items: any[]) {
  return api.updateWidgetNames(items);
}

export async function getFeedbackFormTranslations() {
  return api.feedbackFormTranslations();
}

export async function updateFeedbackFormTranslations(data: any[]) {
  return api.updateFeedbackFormTranslations(data);
}
